
define('text!svgs/sq.svg',[],function () { return '<svg viewBox="0, 0, 100, 100" preserveAspectRatio="none">\n    <polygon points="50,0 100,50 50,100 0,50" vector-effect="non-scaling-stroke"></polygon>\n</svg>';});

